import { Footer, Input } from '@bpinternal/ui-kit-next'
import { useState } from 'react'
import { useCreateKnowledgeBase } from '~/features/knowledge-bases/hooks/useKnowledgeBase'

type AddKBDialogProps = {
  workspaceId: string
  botId: string
  close: () => void
}

export const AddKBDialog = ({ workspaceId, botId, close }: AddKBDialogProps) => {
  const [kbName, setKbName] = useState('')

  const { mutate: createKnowledgeBase, isPending } = useCreateKnowledgeBase()

  const onConfirm = async () => {
    if (kbName.length > 0) {
      createKnowledgeBase({ name: kbName, workspaceId, botId }, { onSettled: close })
    }
  }

  return (
    <div className="flex flex-col gap-4">
      <p className="text-sm text-muted-foreground">This is the name you will see in your knowledge base list.</p>
      <Input
        value={kbName}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            onConfirm()
          }
        }}
        onChange={(e) => {
          setKbName(e.target.value)
        }}
        placeholder="Knowledge Base name"
      />
      <Footer loading={isPending} onConfirm={onConfirm} disabled={kbName.length === 0} />
    </div>
  )
}
